module.exports = __webpack_public_path__ + "static/media/MoneyAdd.478c2632.svg";